import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Team, TeamManagementService} from '../../../../services/api/team-management.service';
import {getFirstLetters} from '../../../../common/utils/helpers';
import {AutoUnsubscribe} from '../../../../decorators/auto-unsubscribe.decorator';
import {SUBSCRIPTIONS} from 'src/app/common/utils/constants';
import {UserPermissionsService} from 'src/app/services/user-permissions.service';
import {AuthService} from 'src/app/auth/shared/services/auth.service';
import {UserInfoQuery} from 'src/app/common/elf-store/user-info/user-info.query';
import {filter, switchMap, take} from 'rxjs';
import {EventEmitterService} from 'src/app/services/event-emitter.service';
import {UserPermissions} from 'src/app/common/elf-store/user-permissions/user-permissions.store';
import {Router} from '@angular/router';
import {TeamQuery} from '../../../../common/elf-store/team/team.query';
import {IUnitDto} from '../../../../common/models/interfaces';

@Component({
  selector: 'mc-team-nav-link-group-feature',
  templateUrl: './team-nav-link-group-feature.component.html',
  styleUrls: ['./team-nav-link-group-feature.component.scss'],
})
@AutoUnsubscribe()
export class TeamNavLinkGroupFeatureComponent implements OnInit, OnDestroy {
  @Input() loading?: boolean;
  @Input() isSidenavOpened: boolean;
  teamShortName: string;
  teamData: IUnitDto;
  constructor(
    public teamManagementService: TeamManagementService,
    private userPermissionsService: UserPermissionsService,
    private authService: AuthService,
    private userInfoQuery: UserInfoQuery,
    private eventEmitterService: EventEmitterService,
    private router: Router,
    private teamQuery: TeamQuery,
  ) {}

  get isTeamPage() {
    return this.router.url.includes('/team');
  }

  ngOnInit(): void {
    this.authService.isUserSwitchedToTeam
      ? this[SUBSCRIPTIONS].add(
          this.userPermissionsService
            .checkUserPermissions(UserPermissions.manageTeam.teamManagementPage.editTeamService)
            .subscribe(isUserAllowed => (isUserAllowed ? this.loadTeamData() : this.getTeamDataFromMembership())),
        )
      : this.loadTeamData();

    this[SUBSCRIPTIONS].add(
      this.userInfoQuery.userInfo$
        .pipe(
          filter(userInfo => !!userInfo.ssoUserId || !!userInfo.id),
          switchMap(info => {
            const targetId = this.authService.uWTargetSwitchId || info.ssoUserId || info.id;
            return this.userPermissionsService.loadUserPermissions(targetId);
          }),
        )
        .subscribe(),
    );

    this[SUBSCRIPTIONS].add(
      this.teamQuery.teamData$.subscribe(teamData => {
        this.teamData = teamData as IUnitDto;
      }),
    );
  }

  loadTeamData() {
    this[SUBSCRIPTIONS].add(
      this.teamManagementService.getTeamData().subscribe(() => {
        this.getTeamShortName();
      }),
    );
  }

  getTeamShortName() {
    this.teamShortName = getFirstLetters(this.teamData.name || '').slice(0, 2);
  }

  getTeamDataFromMembership() {
    this.teamManagementService.loadActiveMembership().subscribe(response => {
      const currentTeam = response.find(
        item => item.myMembershipTeamOwnerAccountId === this.authService.uWTargetSwitchId,
      );
      this.teamManagementService.updateTeamData({
        name: currentTeam?.myMembershipTeamName,
        teamMembersCount: null,
        teamMembers: {
          teamImageUrl: currentTeam?.myMembershipTeamOwnerPictureUrl,
        },
      } as Team);
      this.getTeamShortName();
    });
  }

  goToTeamPage(event: Event) {
    event.preventDefault();
    this[SUBSCRIPTIONS].add(
      this.userPermissionsService
        .checkUserPermissions([
          UserPermissions.manageTeam.teamManagementPage.editTeamService,
          UserPermissions.manageTeam.teamManagementPage.enforce2FAService,
          UserPermissions.manageTeam.teamManagementPage.inviteTeamMemberService,
        ])
        .pipe(take(1))
        .subscribe(userHavePermission => {
          if (!userHavePermission) {
            this.eventEmitterService.showForbiddenDialog.next(true);
          } else {
            this.router.navigate(['account-management', 'account', this.teamData.id]);
          }
        }),
    );
  }

  ngOnDestroy() {
    this.teamManagementService.clearTeamData();
  }
}
